<div class="react-frame">
  <div class="react-frame-loading" *ngIf="isLoading">
    <i class="fa fa-circle-o-notch fa-spin fa-2x" aria-hidden="true"></i>
  </div>
  <iframe #frame
    class="react-frame-body"
    [src]="src"
    [title]="title"
    (load)="onLoad()">
  </iframe>
</div>
